import React from 'react';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { formActions } from './store/forms-reducer';

/*
  props:
    label: form label
    fallbackMessage:
    containerStyle
    itemStyle
    maxNum
    verbose    (not yet)
*/

const FormState = (props) => {
  const formLabel = props.label ?? 'defaultForm';
  const theForm = useSelector(state => state.forms.forms[formLabel])

  if ( theForm === undefined || theForm === null || Object.keys(theForm).length === 0 ) {
    return <div>{props.fallbackMessage || `Please fill in form ${formLabel}`} </div>
  }

  const messages=[]
  //console.log( formLabel );
  for(let key in theForm.entries) {
    if ( key.startsWith('X')) continue;
    if (!theForm.state[key].valid) {
      let message = `${theForm.entries[key].label}: ${theForm.entries[key].errorMessage || 'Enter valid value'}`
      //console.log( message );
      messages.push( message );
    }
  }

  return <>
    <ul>
      {messages.map( (m,i) => <li key={i}>{m}</li>)}
    </ul>
  </>

};

export default FormState;